import Constants from '@usas/ui-web/utils/Constants';
import { isValidDate } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};

  if (formState.orgUnitId === '') {
    errors.orgUnitId = 'Organization is required';
  }

  if (formState.seasonId < 0 && formState.startDate === Constants.BLANK_DATE_STRING ) {
    errors.seasonId = 'Select a Season Year or enter a Start Date / End Date';
  }

  if (formState.startDate !== Constants.BLANK_DATE_STRING && formState.endDate === Constants.BLANK_DATE_STRING) {
    errors.endDate = 'End Date is required if Start Date is entered';
  }

  if (formState.endDate !== Constants.BLANK_DATE_STRING && formState.startDate === Constants.BLANK_DATE_STRING) {
    errors.startDate = 'Start Date is required if End Date is entered';
  }

  // Blank stays legal. The pickers allow impossible dates like 02/31.
  if (formState.startDate !== Constants.BLANK_DATE_STRING
    && isValidDate(formState.startDate) === false) {
    errors.startDate = 'Start Date must be a valid date';
  }

  if (formState.endDate !== Constants.BLANK_DATE_STRING
    && isValidDate(formState.endDate) === false) {
    errors.endDate = 'End Date must be a valid date';
  }

  // Order only compares real dates. new Date() rolls 02/31 over and hides the fault.
  if (formState.startDate !== Constants.BLANK_DATE_STRING && formState.endDate !== Constants.BLANK_DATE_STRING
    && isValidDate(formState.startDate) === true && isValidDate(formState.endDate) === true) {
    if (new Date(formState.startDate) > new Date(formState.endDate)) {
      errors.startDate = 'Start Date cannot be after End Date';
      errors.endDate = 'End Date cannot be before Start Date';
    }
  }

  if (formState.seasonId > 0 && formState.startDate !== Constants.BLANK_DATE_STRING) {
    errors.startDate = 'Cannot enter both a Season Year and a Start Date / End Date';
  }

  return errors;
};

const MeetDetailKendoReportValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default MeetDetailKendoReportValidation;